import { List, Record } from 'immutable';
import { tFunctionType } from 'app/components/localization';

export enum StatusFilterId {
  HasIssues = 'has_issues',
  Published = 'has_published',
  Changed = 'has_changes',
  TieUp = 'tie_up',
  Exam = 'exam',
}

// Implements Dropdown protocol
export class StatusFilter<Id extends StatusFilterId> {
  public constructor(
    public readonly id: Id,
    public readonly getName: (t: tFunctionType) => string,
  ) {}
}

export const HAS_ISSUES = new StatusFilter(
  StatusFilterId.HasIssues,
  (t) => t('admin.editor.publication-status.has-issues'),
);

export const PUBLISHED = new StatusFilter(
  StatusFilterId.Published,
  (t) => t('admin.editor.publication-status.published'),
);

export const CHANGED = new StatusFilter(
  StatusFilterId.Changed,
  (t) => t('admin.editor.publication-status.changed'),
);

export const TIE_UP = new StatusFilter(
  StatusFilterId.TieUp,
  (t) => t('admin.editor.publication-status.tie-up'),
);

export const EXAM = new StatusFilter(
  StatusFilterId.Exam,
  (t) => t('admin.editor.publication-status.exam'),
);

export const STATUS_FILTERS = List([HAS_ISSUES, PUBLISHED, CHANGED, TIE_UP, EXAM]);

export const STATUS_FILTERS_MAP: { [Id in StatusFilterId]: StatusFilter<Id> } = {
  [StatusFilterId.HasIssues]: HAS_ISSUES,
  [StatusFilterId.Published]: PUBLISHED,
  [StatusFilterId.Changed]:   CHANGED,
  [StatusFilterId.TieUp]:     TIE_UP,
  [StatusFilterId.Exam]:      EXAM,
};

// Record type that can accepts StatusFilter IDs as its values. Sets the values to be false by
// default.
export class StatusFilterSearchQuery extends Record<{ [K in StatusFilterId]: boolean | undefined }>({
  has_issues:    undefined,
  has_published: undefined,
  has_changes:   undefined,
  tie_up:        undefined,
  exam:          undefined,
}) {}
